// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_1wrMPUmU27","title":"_1smPdAHr7l","subTitle":"_10LrqXSgLR","faqContainer":"_1lAVFtHzH0"};